<template>
    <v-card outlined class="pa-4 custom-graph-loader" min-height="250">
        <div class="text-center text-caption grey--text">{{ $t("message.loading_graph") }}</div>
        <div class="graph-wrapper">
            <div v-if="type === 'bars'" class="graph-container d-flex align-end justify-space-around">
                <div v-for="n in 8" :key="n" class="graph-bar"
                    :style="{ height: randomHeight(), animationDelay: `${n * 0.1}s` }"></div>
            </div>

            <div v-else class="graph-container">
                <svg viewBox="0 0 100 40" preserveAspectRatio="none" class="line-svg">
                    <path d="M0 30 Q 15 10, 30 25 T 60 15 T 100 25" fill="none" stroke="#eeeeee" stroke-width="2"
                        stroke-linecap="round" class="line-path" />
                </svg>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'GraphLoader',
    props: {
        type: {
            type: String,
            default: 'bars' // accepts 'bars' or 'line'
        }
    },
    methods: {
        randomHeight() {
            // Logic for bar heights to ensure they look like real data
            return Math.floor(Math.random() * (85 - 20 + 1) + 20) + '%';
        }
    }
}
</script>

<style scoped>
.custom-graph-loader {
    background-color: white !important;
    border-color: rgba(0, 0, 0, 0.12) !important;
}

.graph-wrapper {
    height: 180px;
    width: 100%;
    overflow: hidden;
    position: relative;
}

.graph-container {
    height: 100%;
    width: 100%;
}

/* --- BARS STYLING --- */
.graph-bar {
    width: 8%;
    background-color: #eeeeee;
    border-radius: 4px 4px 0 0;
    animation: pulse-opac 1.5s ease-in-out infinite;
}

/* --- LINE STYLING --- */
.line-svg {
    width: 100%;
    height: 100%;
    display: block;
}

.line-path {
    /* Using stroke-dash to create the drawing effect */
    stroke-dasharray: 200;
    stroke-dashoffset: 200;
    animation:
        line-draw 2.5s infinite alternate,
        pulse-opac 1.5s infinite;
}

/* --- ANIMATIONS --- */
@keyframes pulse-opac {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}

@keyframes line-draw {
    from {
        stroke-dashoffset: 200;
    }

    to {
        stroke-dashoffset: 0;
    }
}
</style>